import { render, staticRenderFns } from "./_AssignStationModal.vue?vue&type=template&id=196c9874&scoped=true&"
import script from "./_AssignStationModal.vue?vue&type=script&lang=js&"
export * from "./_AssignStationModal.vue?vue&type=script&lang=js&"
import style0 from "./_AssignStationModal.vue?vue&type=style&index=0&id=196c9874&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196c9874",
  null
  
)

export default component.exports